import React from 'react';
import { Shield, Clock, Award } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const WhyChooseUs = ({ config = {} }) => {
  const [ref, isVisible] = useScrollAnimation();
  
  const defaultReasons = [
    {
      icon: 'Shield',
      title: 'Te protegemos',
      description: 'Lo que no publiquemos se mantiene privado. Eliminamos filtraciones antes de que se difundan y mantenemos contacto directo con las plataformas. Tenemos experiencia directa en la industria y sabemos lo importante que es la seguridad real para las creadoras.',
      image: 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/fvji2v5y_IMG_6783.JPG'
    },
    {
      icon: 'Clock',
      title: 'Somos más rápidos',
      description: 'Mientras duermes, nosotros trabajamos en tu éxito. Nuestro equipo gestiona tus chats 24/7, interactúa activamente, vende eficazmente y te respalda. Puedes concentrarte completamente en tu contenido mientras nosotros nos ocupamos de todo detrás de escena.',
      image: 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/va1m8btv_IMG_6784.JPG'
    },
    {
      icon: 'Award',
      title: 'Somos competitivos',
      description: 'Trabajamos de la mano de altas exponentes de la industria. Nuestra red de contactos y experiencia nos permite ofrecerte las mejores oportunidades y estrategias para maximizar tu potencial y convertirte en una referente del sector.',
      image: 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/fxax7thb_IMG_6785.JPG'
    }
  ];
  
  const reasons = config.whySection || defaultReasons;
  const iconMap = { Shield, Clock, Award };

  return (
    <section ref={ref} id="servicios" className="py-24 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, #c8784e 0%, transparent 50%), radial-gradient(circle at 80% 80%, #c8784e 0%, transparent 50%)'
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
          <p className="text-[#c8784e] uppercase tracking-wider mb-4 font-semibold">Excelencia y profesionalismo</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            ¿Por qué elegir JGM?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = iconMap[reason.icon] || Shield;
            return (
              <div
                key={index}
                className={`group relative overflow-hidden rounded-2xl bg-[#1d1e20] hover:bg-[#252628] transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-[#c8784e]/20 stagger-item delay-${(index + 1) * 200} ${isVisible ? 'visible' : ''}`}
              >
                <div className="absolute inset-0 opacity-35 group-hover:opacity-50 transition-opacity duration-500 z-0">
                  <img src={reason.image} alt={reason.title} className="w-full h-full object-cover" />
                </div>

                <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/75 z-5" />
                
                <div className="relative z-10 p-8">
                  <div className="bg-[#c8784e]/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#c8784e]/30 transition-colors duration-300">
                    <IconComponent size={32} className="text-[#c8784e]" />
                  </div>
                  
                  <h3 className="text-2xl font-bold mb-4 text-white">{reason.title}</h3>
                  <p className="text-gray-300 group-hover:text-white leading-relaxed font-light transition-colors duration-300">{reason.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;